<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getIp, getInfo } from '@/api/base'
import { getI18nLocale } from '@/lang/config'

const USER_INFO_REFRESH_INTERVAL = 30 * 60 * 1000

export default {
  name: 'App',
  data() {
    return {
      userInfoTimer: null
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    }
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(val) {
        if (val) {
          this.startUserInfoRefresh()
        } else {
          this.stopUserInfoRefresh()
        }
      }
    }
  },
  created() {
    this.initLanguageByIp()
  },
  beforeDestroy() {
    this.stopUserInfoRefresh()
  },
  methods: {
    startUserInfoRefresh() {
      if (this.userInfoTimer) return
      this.userInfoTimer = setInterval(() => {
        this.refreshUserInfo()
      }, USER_INFO_REFRESH_INTERVAL)
    },
    stopUserInfoRefresh() {
      if (!this.userInfoTimer) return
      clearInterval(this.userInfoTimer)
      this.userInfoTimer = null
    },
    refreshUserInfo() {
      if (!this.$store.getters.isLoggedIn) return
      getInfo().then(res => {
        this.$store.dispatch('updateUser', res.data)
      }).catch(() => {})
    },
    initLanguageByIp() {
      if (localStorage.getItem('language')) return
      getIp().then(res => {
        let ip_data =  res.data
        if (typeof ip_data === 'string') {
          try {
            ip_data = JSON.parse(ip_data)
          } catch (e) {
            return
          }
        }
        if (!ip_data || !ip_data.data || !ip_data.data.country_code) return
        console.log('COUNTRY_CODE: ', ip_data.data.country_code)
        const lang = this.mapCountryToLang(ip_data.data.country_code)
        this.$store.dispatch('setLanguage', lang)
        this.$i18n.locale = getI18nLocale(lang)
      }).catch(() => {})
    },
    mapCountryToLang(code) {
      switch (String(code).toUpperCase()) {
        case 'CN':
          return 'zh-CN'
        case 'RU':
          return 'ru-RU'
        default:
          return 'en-US'
      }
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

#app .el-input .el-input__inner::placeholder,
#app .el-textarea .el-textarea__inner::placeholder {
  color: #999999 !important;
  opacity: 1;
}

#app .el-input .el-input__inner::-webkit-input-placeholder,
#app .el-textarea .el-textarea__inner::-webkit-input-placeholder {
  color: #999999 !important;
  opacity: 1;
}

#app .el-input .el-input__inner::-moz-placeholder,
#app .el-textarea .el-textarea__inner::-moz-placeholder {
  color: #999999 !important;
  opacity: 1;
}

#app .el-input .el-input__inner:-ms-input-placeholder,
#app .el-textarea .el-textarea__inner:-ms-input-placeholder {
  color: #999999 !important;
  opacity: 1;
}

#app .el-input .el-input__inner::-ms-input-placeholder,
#app .el-textarea .el-textarea__inner::-ms-input-placeholder {
  color: #999999 !important;
  opacity: 1;
}
</style>
